import * as React from 'react';

import '../../styles/lc/index.scss';

const LC = (): JSX.Element => <></>;

export default LC;
